import { Component, Host, h, Prop, Element } from '@stencil/core';
import { validProductPrice, sendEvent } from '../../utils/utils';
import { environment } from '../../global/resources';

@Component({
  tag: 'mo-checkout',
  styleUrl: 'mo-checkout.css',
  shadow: true,
})
export class MoCheckout {
  @Element() el: HTMLElement;
  @Prop() moClientId!: string;
  @Prop() productPrice?: string;
  private observer: IntersectionObserver;
  public urlBase: string = environment.base_url;
  childElement: HTMLElement;
  handleResize: any; // Función que maneja el evento resize
  saveWidth: number;
  componentDidLoad() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    };
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          sendEvent('checkout', 'view');
          observer.unobserve(entry.target);
        }
      });
    }, options);
    observer.observe(this.el);
    this.childElement = this.el.shadowRoot.querySelector('.mo-checkout');
    const rect = this.el.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    // this._handleResize(rect.width, windowWidth);
    this.handleResize = () => {
      const rect = this.el.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      // this._handleResize(rect.width, windowWidth);
    };

    window.addEventListener('resize', this.handleResize);
  }

 
  componentWillLoad() {
    const options = {
      root: null, // Observa con respecto al viewport
      threshold: 0.1 // Al menos el 10% del componente debe ser visible
    };

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // El componente es visible
          this.childElement = this.el.shadowRoot.querySelector('.mo-checkout');
          const rect = this.el.getBoundingClientRect();
          const windowWidth = window.innerWidth;
          // this._handleResize(rect.width, windowWidth);
        }
      });
    }, options);

    this.observer.observe(this.el);
  }

  private _handleResize(width: number, windowWidth) {
    if(width>0){
      if (width <= 700) {
        if(!this.saveWidth){
          this.saveWidth = windowWidth;
        }
        this.childElement.classList.add('mo-mobile');
      } 
      if(width > 700 || windowWidth > this.saveWidth){
        this.saveWidth = undefined;
        this.childElement.classList.remove('mo-mobile');
      }
    }

  
  }
  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
  }
  render() {
    return (
      <Host>
        <slot>
          <section class='mo-checkout mo-mobile'>
            <div class='mo-checkout__info'>
              <h4>Paga cuando elijas <b>con todas las tarjetas de crédito.</b></h4>
              <div class='mo-checkout__items'>
                <div class='mo-checkout__item'>
                  <img  src={`${this.urlBase}/assets/icon-check.svg`}/>
                  <span>
                  Desde <b class='purple'>0% de interés</b>
                  </span>
                </div>
                <div class='mo-checkout__item'>
                  <img  src={`${this.urlBase}/assets/icon-check.svg`}/>
                  <span>
                  <b class='purple'>Sin afectar toda tu línea </b>de crédito
                  </span>
                </div>
                <div class='mo-checkout__item'>
                  <img  src={`${this.urlBase}/assets/icon-check.svg`}/>
                  <span>
                   <b class='purple'>Hoy solo pagarás la primera cuota</b> <br /> 
                  </span>
                </div>
              </div>
              <div class="info-text">
                <img  src={`${this.urlBase}/assets/icon-info.svg`}/>
                  <p > Las demás cuotas se cobrarán automáticamente de la tarjeta de crédito que afilies.
                  </p>
              </div>
              
            </div>
            <div class='mo-checkout__button'>
              <mo-button
                buttonType='checkout'
                price={this.productPrice}
                clientId={this.moClientId}
                offerByPrice={validProductPrice(this.productPrice)}
                gtagCategory='checkout'
                valueText='Más información'
              ></mo-button>
            </div>
          </section>
        </slot>
      </Host>
    );
  }
}
